import { Route } from 'react-router-dom'

import { PublicRouteProps } from './PublicRoute.models'

export const PublicRoute = ({ path, children }: PublicRouteProps): JSX.Element => {
  return <Route path={path}>{children}</Route>
}
